module.exports = __webpack_public_path__ + "images/emoji/u7a7a.32e4049118898968cf0a.png";